import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ReportPageBase } from 'src/shared/Baseclasses/report-page-base';
import { ReportService } from 'src/shared/services/report.service';
import { ReportConstants } from '../shared/report-constants.util';
import { Constants } from 'src/shared/utilities/constants.util';

@Component({
  selector: 'executive-variance-report-page',
  templateUrl: './executive-variance-page.component.html'
})
export class ExecutiveVariancePageComponent extends ReportPageBase implements OnInit {

  views:string[];
  varianceTypes :string[];
  defaultView : string;
  defaultVarianceType: string;

  constructor(private reportService: ReportService){
    super();
  }

  ngOnInit() {

    this.views = [
      ReportConstants.DateViewLabel,
      ReportConstants.DayOfWeekViewLabel,
      ReportConstants.PeriodEndViewLabel,
      ReportConstants.WeekViewLabel
      ];

      this.varianceTypes = [
        ReportConstants.CostCenterLabel,
        ReportConstants.JobTitleLabel
        ];

      this.defaultView = ReportConstants.DateViewLabel;
      this.defaultVarianceType = ReportConstants.CostCenterLabel;
      
    this.reportService.announceSummarySelected(Constants.ExecutiveVariance);
  }
}
